import { useTranslate } from '@tolgee/react'
import { TitleWithCaptionCell, TomTableEmptyCell } from '@tom-ui/ui'
import { FC, ReactNode } from 'react'

type Props = {
  numericReleaseReference?: string | null
  nonNumericReleaseReference?: string | null
  renderedCellValue?: ReactNode
}

export const ReleaseReferenceTableColumn: FC<Props> = props => {
  const { t } = useTranslate()
  const { numericReleaseReference, nonNumericReleaseReference, renderedCellValue } = props

  const isNumericReleaseRefPresent = !!numericReleaseReference
  const isNonNumericReleaseRefPresent = !!nonNumericReleaseReference

  if (!isNumericReleaseRefPresent && !isNonNumericReleaseRefPresent) {
    return <TomTableEmptyCell renderedCellValue />
  }

  const title =
    renderedCellValue ??
    (isNumericReleaseRefPresent ? numericReleaseReference : nonNumericReleaseReference)

  const caption = isNumericReleaseRefPresent
    ? t('numeric', 'Numeric')
    : t('nonNumeric', 'Non-numeric')

  return <TitleWithCaptionCell title={title} caption={caption} />
}
